module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "empty-text": _vm.emptyText,
      "fixed": "",
      "stripe": "",
      "data": _vm.campaigns,
      "height": "350"
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "title",
      "label": "Name",
      "width": _vm.selectorTable ? 420 : 320
    }
  }), _vm._v(" "), (!_vm.selectorTable) ? _c('el-table-column', {
    attrs: {
      "prop": "type",
      "label": "Type"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n        " + _vm._s(_vm.cleanType(scope.row.type)) + "\n      ")]
      }
    }], null, false, 3451053561)
  }) : _vm._e(), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "startDate",
      "label": "Start Date",
      "width": "150"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n        " + _vm._s(_vm.cleanDate(scope.row.startDate)) + "\n      ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "uniques",
      "label": "Uniques"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n        " + _vm._s(_vm.formatNumber(scope.row.uniques)) + "\n      ")]
      }
    }])
  }), _vm._v(" "), (_vm.selectorTable) ? _c('el-table-column', {
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-checkbox', {
          on: {
            "change": _vm.handleChange
          },
          model: {
            value: (scope.row.selected),
            callback: function($$v) {
              _vm.$set(scope.row, "selected", $$v)
            },
            expression: "scope.row.selected"
          }
        })]
      }
    }], null, false, 1264612)
  }) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-418e5462","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"multiple":[{"search":"logo-white[.]svg","replace":"logo-white-live.svg","flags":"g"},{"search":"_variables","replace":"_variables_live","flags":"g"},{"search":"_theme","replace":"_live","flags":"g"}]}!./src/components/profiles/filters/CampaignFilterTable.vue
// module id = 3249
// module chunks = 3